module.exports = __webpack_public_path__ + "static/media/u_trash.83981a16.svg";